webpackJsonp([118155284332726],{

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/retaining-wall-wisconsin.0bd2b26e.jpg";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/retaining-walls-illinois-wisconsin.55b2f578.jpg";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _landscapeDevelopment = __webpack_require__(28);
	
	var _landscapeDevelopment2 = _interopRequireDefault(_landscapeDevelopment);
	
	var _retainingWallsIllinoisWisconsin = __webpack_require__(479);
	
	var _retainingWallsIllinoisWisconsin2 = _interopRequireDefault(_retainingWallsIllinoisWisconsin);
	
	var _retainingWallWisconsin = __webpack_require__(478);
	
	var _retainingWallWisconsin2 = _interopRequireDefault(_retainingWallWisconsin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RetainingWalls = function RetainingWalls() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Retaining Walls & Patio\'s | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _landscapeDevelopment2.default, alt: '' })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Retaining Walls & Patio\'s'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'ICE enterprises not only provides landscaping maintenance, but also development. We provide professional solutions that are under budget and on time.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'col' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        ),
	        ' > ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services' },
	          'Services'
	        ),
	        ' > Retaining Walls & Patios'
	      ),
	      _react2.default.createElement('img', { src: _retainingWallsIllinoisWisconsin2.default, alt: 'Patio project from ICE enterprises' }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Patio\'s'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Concerned about the market value of your home? Increase the value of your house tremendously with one project. Adding a deck provides a high return on investment at 74 percent for composite and 87 percent for wood.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'On top of increasing the value of your home, adding a deck adds \u2018WOW\u2019 factor that\u2019s unmatched. Entertain your friends and family with an outdoor installment that\u2019s perfect for relaxation, cooking, game days, and hosting.'
	      ),
	      _react2.default.createElement('img', { src: _retainingWallWisconsin2.default, style: { marginTop: '2rem' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Retaining walls'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Retaining walls are rigid walls used to retain soil at different levels on both sides. They contain soil to a slope that wouldn\u2019t occur naturally.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Retaining walls are thought of as mostly utilitarian, but can be incorporated into your existing architecture to create a beautiful multi-use outdoor living space. Using unique shapes, terracing, and intricate designs make for beautiful outdoor solutions that add value to your home or property.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Need an architetural solution that\'s not listed? ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:estimates@ice2010.com', target: '__blank' },
	          'Contact us'
	        ),
	        ' today for a custom solution.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Manufacturers we use'
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { marginBottom: "5px" } },
	        _react2.default.createElement(
	          'a',
	          { href: 'http://rohestercp.com/outdoor-living-kits' },
	          'Rocheser Living Kits'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { marginBottom: "5px" } },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.belgard.com' },
	          'Belgard Pavers'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { marginBottom: "5px" } },
	        _react2.default.createElement(
	          'a',
	          { href: 'https://unilock.com' },
	          'Unilock Pavers'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us today and learn more'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	};
	
	exports.default = RetainingWalls;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-retaining-walls-patios-js-76eb5e224d92f2857e77.js